import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";
import { useMemo } from "react";

import { PaintConfiguration } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { ProductsContextProvider } from "./context/products.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const {
        products,
        selectedColor,
        selectedFamily,
        selectedFinish,
        selectedVolume
    } = usePaintConfiguratorContext();

    const encodedState = useMemo(() => {
        if (!selectedColor) {
            return undefined;
        }
        const state: PaintConfiguration = {
            paintInfo: {
                colorHex: selectedColor.hexValue,
                colorName: selectedColor.name,
                colorId: selectedColor.id,
                family: selectedFamily!,
                finish: selectedFinish!.value,
                volume: selectedVolume!.volume.value
            }
        };
        const encodedState = btoa(encodeURIComponent(JSON.stringify(state)));
        return encodedState;
    }, [selectedColor, selectedFamily, selectedFinish, selectedVolume]);

    return (
        <div
            className={cn(
                "tw:w-full tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:lg:grid-cols-3 tw:lg:gap-6 tw:gap-4"
            )}
        >
            <ProductsContextProvider
                products={products}
                urlState={encodedState}
            >
                {children}
            </ProductsContextProvider>
        </div>
    );
};

export { Base };
